import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../config/httpConfig";

export const saveBoardResolution = createAsyncThunk(
    "docs/saveBoardResolution",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await axios.post("/api/common/v1/document/boardResolution", payload);
            return response;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

const DocumentSlice = createSlice({
  name: "docs",
  initialState: {
    loading: false,
    error: null,
  },

  extraReducers: (builder) => {
    builder.addCase(saveBoardResolution.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(saveBoardResolution.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
    });
    builder.addCase(saveBoardResolution.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
  reducers: {},
});

// eslint-disable-next-line no-empty-pattern
export const {} = DocumentSlice.actions;

export default DocumentSlice.reducer;
